import { render } from "./PersonReport.vue?vue&type=template&id=55c05e19&scoped=true"
import script from "./PersonReport.vue?vue&type=script&lang=js"
export * from "./PersonReport.vue?vue&type=script&lang=js"

import "./PersonReport.vue?vue&type=style&index=0&id=55c05e19&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c05e19"]])

export default __exports__